import { HttpClient } from '../httpClient';
import ChangePassword from '../models/changePassword';
import User from '../models/user';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import DisciplinesResponse from '../responses/disciplinesResponse';
import StringResponse from '../responses/stringResponse';
import UpdateProfileResponse from '../responses/updateProfileResponse';
import UserResponse from '../responses/userResponse';

const httpClient = new HttpClient();

export const getMe = async () => {
  return httpClient.get<StringResponse>({
    url: '/v1/me',
    requiresToken: true,
  });
};

export const getMyProfile = async () => {
  return httpClient.get<UserResponse>({
    url: '/v1/me/profile',
    requiresToken: true,
  });
};

export const updateMyProfile = async (profile: User) => {
  return httpClient.put<UpdateProfileResponse>({
    url: '/v1/me/profile',
    payload: profile,
    requiresToken: true,
  });
};

export const updateMyPassword = async (changePassword: ChangePassword) => {
  return httpClient.put<BaseResponse>({
    url: '/v1/me/update-password',
    payload: changePassword,
    requiresToken: true,
  });
};

export const getDisciplines = async () => {
  return httpClient.get<DisciplinesResponse>({
    url: '/v1/me/disciplines',
    requiresToken: true
  });
};

export const getCurrentUser = async () => {
  return httpClient.get<DataResponse<User>>({
    url: `/v1/Users/Current`,
    requiresToken: true,
  });
};